import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl-next';
import { isFedRamp } from '@atlaskit/atlassian-context';
import Button from '@atlaskit/button';
import EmptyState from '@atlaskit/empty-state';
import commonMessages from '../../messages';
import ErrorSVG from './error-svg';
import messages from './messages';
export var CONTACT_SUPPORT_LINK = 'https://support.atlassian.com/contact/';
export var CONTACT_SUPPORT_LINK_FEDRAMP = 'https://gcs.atlassian-us-gov-mod.net/servicedesk/customer/portals';
export var ErrorBoundaryUI = function ErrorBoundaryUI() {
  var intl = useIntl();
  return /*#__PURE__*/React.createElement(EmptyState, {
    maxImageWidth: 82,
    testId: 'link-create-error-boundary-ui',
    header: intl.formatMessage(commonMessages.genericErrorMessage),
    description: /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, messages.description, {
      values: {
        a: function a(label) {
          return /*#__PURE__*/React.createElement(Button, {
            appearance: "link",
            spacing: "none",
            href: isFedRamp() ? CONTACT_SUPPORT_LINK_FEDRAMP : CONTACT_SUPPORT_LINK,
            target: "_blank",
            rel: "noopener noreferrer"
          }, label);
        }
      }
    })),
    renderImage: function renderImage() {
      return /*#__PURE__*/React.createElement(ErrorSVG, null);
    }
  });
};